<script>
    import { Tabs, Tab } from 'vue-tabs-component';
    import vSelect from 'vue-select'


    export default {
        name: 'pagePricing',
        layout: 'default',

        components: {
            Tabs,
            Tab,
            vSelect
        },

        data: () => {
            return {
                /**
                 * @type: Object
                 **/
                selectedPremium: { label: 'до 100 Клиентов', value: 100 },

                /**
                 * @type {Object}
                 **/
                selectedExtream: { label: 'до 500 Клиентов', value: 500 },

                /**
                 * @type {Number}
                 **/
                premiumPrice: 0,

                /**
                 * @type {Number}
                 **/
                extreamPrice: 0,

                /**
                 * @desc Может ли списоко быть очищен пользователем
                 * @type {Boolean}
                 **/
                clearable: false
            }
        },

        methods: {
            /**
             * @desc Обработка событий выбора опции
             **/
            onPreminumCalculatorChange (selected) {
                this.premiumPrice = selected.value;
            },

            /**
             * @desc Обработка событий выбора опции
             **/
            onExtreamCalculatorChange (selected) {
                this.extreamPrice = selected.value;
            },
        },

        computed: {
            /**
             * @desc Наш сервер
             * @return {String}
             **/
            sCloudService () {
                return '<i class="fa fa-cloud" aria-hidden="true"></i>&nbsp;Облако';
            },

            /**
             * @desc Саморазмещение
             * @return {String}
             **/
            sSeflHostedService () {
                return '<i class="fa fa-server" aria-hidden="true"></i>&nbsp;Клиентское размещение';
            },

            /**
             * @return {Array}
             **/
            premiumOptions () {
                return [
                    { label: 'до 100 Клиентов', value: 100 },
                    { label: 'до 300 Клиентов', value: 300 },
                    { label: 'до 500 Клиентов', value: 500 },
                    { label: 'до 1000 Клиентов', value: 1000 },
                    { label: '2500+ Клиентов', value: 2500 }
                ];
            },

            /**
             * @return {Array}
             **/
            extreamOptions () {
                return [
                    { label: 'до 500 Клиентов', value: 500 },
                    { label: 'до 1000 Клиентов', value: 1000 },
                    { label: 'до 3000 Клиентов', value: 3000 },
                    { label: 'до 5000 Клиентов', value: 5000 },
                    { label: '10000+ Клиентов', value: 10000 }
                ];
            },

            /**
             * @desc Расчет сто
             **/
            premiumSum () {
                let price = 50;

                if (this.premiumPrice > 1000) {
                    price = 4500
                } else if (this.premiumPrice > 500) {
                    price = 3000
                } else if (this.premiumPrice > 300) {
                    price = 2000
                } else if (this.premiumPrice > 100) {
                    price = 1500
                }

                return this.$n(price, 'currency')
            },


            /**
             * @desc Расчет сто
             **/
            extreamSum () {
                let price = 1500;

                if (this.extreamPrice > 5000) {
                    price = 8000
                } else if (this.extreamPrice > 3000) {
                    price = 6000
                } else if (this.extreamPrice > 1000) {
                    price = 4100
                } else if (this.extreamPrice > 500) {
                    price = 3000
                } else if (this.extreamPrice > 300) {
                    price = 2000
                } else if (this.extreamPrice > 100) {
                    price = 1500
                }

                return this.$n(price, 'currency')
            },
        }
    }
</script>

<template>
    <div class="pricing">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <tabs>
                        <tab :name="sCloudService" id="cloud">
                            <h1 class="title">Система за несколько кликов мышкой</h1>
                            <h2 class="sub-title">Мы предоставляем готовую к использованию систему, <br>которая устанавливается на сервере компании SportService.
                            </h2>
                            <div class="row">
                                <div class="col-md-6 col-sm-12 col-xs-12">
                                    <div class="pricing-item pricing__standard">
                                        <div class="pricing-header">
                                            <div class="price-coverage platinum_coverage"></div>
                                            <div class="text-wrapper text-center">
                                                <h1>Standard</h1>
                                                <h2>$10 в месяц / до 100 клиентов</h2>
                                            </div>
                                        </div>
                                        <div class="pricing-content">
                                            <div class="pricing-description">
                                                <ul>
                                                    <li>Размещение системы клиента на серверах компании SportService (в виде поддоменна "<strong>EXAMPLE</strong>.SPORTSERVICE.COM.UA" )</li>
                                                    <li>Клиентская поддержка</li>
                                                    <li>Периодические обновления системы</li>
                                                    <li>&nbsp;</li>
                                                </ul>
                                            </div>

                                            <div class="col-12 button-wrapper">
                                                <a href="http://demo.sportservice.com.ua/" target="_blank" class="btn btn-light">Попробовать бесплатно</a>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                                <div class="col-md-6 col-sm-12 col-xs-12">
                                    <div class="pricing-item pricing__flex">
                                        <div class="pricing-header">
                                            <div class="price-coverage gold_coverage"></div>
                                            <div class="text-wrapper text-center">
                                                <h1>Gold</h1>
                                                <h2>$0.15 за каждого клиента / от 100 клиентов</h2>
                                            </div>
                                        </div>
                                        <div class="pricing-content">
                                            <div class="pricing-description">
                                                <ul>
                                                    <li>Размещение системы клиента на серверах компании SportService (в виде поддоменна "<strong>EXAMPLE</strong>.SPORTSERVICE.COM.UA" )</li>
                                                    <li>Клиентская поддержка</li>
                                                    <li>Периодические обновления системы</li>
                                                    <li>Периодическая архивация данных</li>
                                                </ul>
                                            </div>

                                            <div class="col-12 button-wrapper">
                                                <a href="http://demo.sportservice.com.ua/" target="_blank" class="btn btn-light">Попробовать бесплатно</a>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </tab>
                        <tab :name="sSeflHostedService" id="self_hosted">
                            <h1 class="title">Сервер Клиента</h1>
                            <h2 class="sub-title">Система устанавливается и настраивается <br>на сервере Клиента специалистами компании SportService.
                            </h2>
                            <div class="row">
                                <!--<div class="col-md-6 col-sm-12 col-xs-12">-->
                                    <!--<div class="pricing-item pricing__standard">-->
                                        <!--<div class="pricing-header">-->
                                            <!--<div class="price-coverage gold_coverage"></div>-->
                                            <!--<div class="text-wrapper text-center">-->
                                                <!--<h1>Сервер</h1>-->
                                                <!--<h2 class="price" v-html="premiumSum"></h2>-->
                                                <!--<h3>единоразово</h3>-->
                                                <!--<div>-->
                                                    <!--<v-select v-model="selectedPremium"-->
                                                              <!--:clearable="clearable"-->
                                                              <!--:searchable="false"-->
                                                              <!--:on-change="onPreminumCalculatorChange"-->
                                                              <!--:options="premiumOptions">-->
                                                    <!--</v-select>-->
                                                <!--</div>-->
                                            <!--</div>-->
                                        <!--</div>-->
                                        <!--<div class="pricing-content">-->
                                            <!--<div class="pricing-description">-->
                                                <!--<ul>-->
                                                    <!--<li>Размещение системы на наших серверах</li>-->
                                                    <!--<li>Поддержка и помощь</li>-->
                                                    <!--<li>Бесплатные обновления системы</li>-->
                                                <!--</ul>-->
                                            <!--</div>-->

                                            <!--<div class="col-12 button-wrapper">-->
                                                <!--<a href="#" class="btn btn-light">Попробовать бесплатно</a>-->
                                            <!--</div>-->
                                        <!--</div>-->
                                    <!--</div>-->

                                <!--</div>-->
                                <div class="col-md-12 col-sm-12 col-xs-12">
                                    <div class="pricing-item pricing__standard">
                                        <div class="pricing-header">
                                            <div class="price-coverage platinum_coverage"></div>
                                            <div class="text-wrapper text-center">
                                                <h1>Премиум</h1>
                                                <h2 class="price" v-html="extreamSum"></h2>
                                                <h3>за год</h3>
                                                <div>
                                                    <v-select v-model="selectedExtream"
                                                              :clearable="clearable"
                                                              :searchable="false"
                                                              :on-change="onExtreamCalculatorChange"
                                                              :options="extreamOptions">
                                                    </v-select>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="pricing-content">
                                            <div class="pricing-description">
                                                <ul>
                                                    <li> Размещение системы на наших серверах </li>
                                                    <li> Поддержка и помощь </li>
                                                    <li> Бесплатные обновления системы </li>
                                                </ul>
                                            </div>

                                            <div class="col-12 button-wrapper">
                                                <a href="http://demo.sportservice.com.ua/" target="_blank" class="btn btn-light">Попробовать бесплатно</a>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </tab>
                    </tabs>
                </div>
            </div>
        </div>
    </div>
</template>




// WEBPACK FOOTER //
// resources/assets/js/pages/pricing.vue